import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "padding-auth-contents" }
const _hoisted_2 = { class: "py-4" }
const _hoisted_3 = { class: "mb-6" }
const _hoisted_4 = { class: "mb-6" }
const _hoisted_5 = { class: "mb-6" }
const _hoisted_6 = { class: "mb-6" }
const _hoisted_7 = { class: "text-subtitle-underline" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_home_latest_notice = _resolveComponent("home-latest-notice")!
  const _component_banner = _resolveComponent("banner")!
  const _component_home_latest_browsing = _resolveComponent("home-latest-browsing")!
  const _component_course_list_contents = _resolveComponent("course-list-contents")!
  const _component_layouts_auth_width = _resolveComponent("layouts-auth-width")!
  const _component_layouts_auth = _resolveComponent("layouts-auth")!

  return (_openBlock(), _createBlock(_component_layouts_auth, null, {
    default: _withCtx(() => [
      _createVNode(_component_layouts_auth_width, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_home_latest_notice, { notices: _ctx.latestNotices }, null, 8, ["notices"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_banner)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_home_latest_browsing, { browsings: _ctx.latestBrowsings }, null, 8, ["browsings"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.t('course.title')), 1),
                _createVNode(_component_course_list_contents)
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}